// src/components/AnimatedCounter.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

export default function AnimatedCounter  ({ start, end, duration }) {
  const [count, setCount] = useState(start);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      setCount(Math.floor(progress * (end - start) + start));

      if (progress === 1) {
        clearInterval(interval);
      }
    }, 16);

    return () => clearInterval(interval);
  }, [start, end, duration]);

  return (
    <div className="">
      <p className="text-4xl font-bold text-blue-500">
        {count.toLocaleString()}
      </p>
    </div>
  );
};

AnimatedCounter.propTypes = {
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
};


